import { isAxiosError } from "axios";

export type LogLevel = "warning" | "error";

export class LeveledError extends Error {
	level: LogLevel;
	constructor(message: string, level: LogLevel = "error") {
		super(message);
		this.level = level;
	}
}

const UI_VISIBLE_ERROR_TYPE = "UIVisibleError";

/**
 * The i18n key a backend `UIVisibleError` carries — `{ detail: { error_type, message } }` — or
 * undefined for any other failure, so the caller picks its own message for those.
 */
export const uiVisibleErrorKey = (error: unknown): string | undefined => {
	if (!isAxiosError<{ detail?: unknown }>(error)) return undefined;
	const detail = error.response?.data?.detail;
	if (typeof detail !== "object" || detail === null || !("error_type" in detail) || !("message" in detail)) return undefined;
	return detail.error_type === UI_VISIBLE_ERROR_TYPE && typeof detail.message === "string" ? detail.message : undefined;
};
